(function ($, Drupal, once) {

  'use strict';

  Drupal.behaviors.weaver_animations = {
	  
	  attach: function (context, settings) {

      // ensures javascript runs only once per page load and not with every ajax call
      $(once('weaver_animations', 'body', context)).each(function () {

        const logoPolygons = document.querySelectorAll('.site-logo polygon');
        if (logoPolygons != null) {
          logoPolygons.forEach((polygon) => {
            polygon.addEventListener('animationstart', () => {
              polygon.classList.add('animated');
            });
          });
        }
      });
    }
  };


})(jQuery, Drupal, once);
